import React, { useEffect } from "react";
import { Select, Form } from "antd";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { attributes } from "../../../store/features/product/productSlice";

const AttributesDetails = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const productStoreDetails = useSelector((state) => state.product.product);
  const { Option } = Select;

  useEffect(() => {
    productStoreDetails.selectedAttributs.map((data) => {
      form.setFieldsValue({
        [data.name]: data.value,
      });
    });
  }, []);

  return (
    <div className="mt-4">
      <Form form={form} layout={"vertical"} autoComplete="off">
        {productStoreDetails.attributes.map((data, index) => (
          <Form.Item
            className="text-start"
            label={data.variant.name}
            name={data.variant.name}
            key={index}
          >
            <Select
              showSearch
              size="large"
              mode="multiple"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(input) => {
                dispatch(
                  attributes({
                    id: data.variant.id,
                    name: data.variant.name,
                    value: input,
                  })
                );
              }}
            >
              {data.variant.Attributes.map((i, index) => (
                <Option key={i.id} value={i.id}>
                  {i.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        ))}
      </Form>
    </div>
  );
};

export default AttributesDetails;
